import React, { memo } from 'react';
import { useSlateStatic, useSlateSelector } from 'slate-react';
import Button from '../common/Button';
import Icon from '../common/Icon';
import { activeMark, addMarkData, isBlockActive, isMarkActive, toggleBlock, toggleMark } from '../utils/SlateUtilityFunctions';
import styles from './Toolbar.module.scss';

// Optimized BlockButton using useSlateSelector to only re-render when active state changes
export const BlockButton = memo(({ format, icon }: { format: string; icon: string }) => {
    const editor = useSlateStatic();
    const isActive = useSlateSelector((state) => isBlockActive(state, format));

    return (
        <Button
            active={isActive}
            format={format}
            onMouseDown={(e: React.MouseEvent) => {
                e.preventDefault();
                toggleBlock(editor, format);
            }}
        >
            {/* @ts-ignore */}
            <Icon icon={icon} />
        </Button>
    );
});

// Optimized MarkButton using useSlateSelector
export const MarkButton = memo(({ format, icon }: { format: string; icon: string }) => {
    const editor = useSlateStatic();
    const isActive = useSlateSelector((state) => isMarkActive(state, format));

    return (
        <Button
            active={isActive}
            format={format}
            onMouseDown={(e: React.MouseEvent) => {
                e.preventDefault();
                toggleMark(editor, format);
            }}
        >
            {/* @ts-ignore */}
            <Icon icon={icon} />
        </Button>
    );
});

// Optimized Dropdown using useSlateSelector
export const Dropdown = memo(({ format, options }: { format: string; options: Array<{ value: string; text: string }> }) => {
    const editor = useSlateStatic();
    const value = useSlateSelector((state) => activeMark(state, format));

    const changeMarkData = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        const val = event.target.value;
        addMarkData(editor, { format, value: val });
    };

    // Default to 12px for fontSize when no mark exists (matches editor CSS default)
    const displayValue = value || (format === 'fontSize' ? '12px' : '');

    return (
        <select value={displayValue} onChange={changeMarkData} className={styles.Select}>
            {options.map((item, index) => (
                <option key={index} value={item.value}>
                    {item.text}
                </option>
            ))}
        </select>
    );
});
